module.exports = __webpack_public_path__ + "971aa85cdece0821508af523efa17c10.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/184.png
// module id = 1767
// module chunks = 2